import React from "react";
import { Typography } from "antd";
import CompanyDetails from "./CompanyDetails";
import PatientDetails from "./PatientDetails";
import Plan from "./Plan";
import OrderDetails from "./OrderDetails";
import AdditionalDetails from "./AdditionalDetails";
import PrintWrapper from "./PrintWrapper.style";

const { Title } = Typography;

const PrintOrder = (props) => {
  const { order } = props;
  const selectedOrder = order || {};
  return (
    <PrintWrapper>
      <div className="pdf" dir="rtl">
        <div style={{ height: "100vh" }}>
          <CompanyDetails />
          <Title
            style={{
              fontSize: "30px",
              fontWeight: 500,
              lineHeight: 1.27,
              color: "rgba(0, 0, 0, 0.85)",
              margin: "0",
            }}
          >
            הזמנת שירות
          </Title>
          <div className="verticalSeperator" />
          <PatientDetails order={selectedOrder} />
          <div className="verticalSeperator" />
          <OrderDetails order={selectedOrder} />
          <div className="verticalSeperator" />
          <AdditionalDetails order={selectedOrder} />
          <div />
        </div>
        <div>
          <CompanyDetails />
          <div className="verticalSeperator" />
          <PatientDetails order={selectedOrder} />
          <div className="verticalSeperator" />
          <Plan order={selectedOrder} />
          <div className="verticalSeperator" />
        </div>
      </div>
    </PrintWrapper>
  );
};

export default PrintOrder;
